<div *ngIf="screen === 'APPOINTMENTS'" class="row mb-2 mr-0">
  <div class="col-12 text-right">
    <!--Calendar/List View-->
    <app-list-mode [contextMode]="'calendar'" [storageKey]="'appointments-calendar-list'" [titleKey]="'VIEW'"
      (collapsibleToggle)="viewModeChanged($event)">
    </app-list-mode>
  </div>
</div>

<!--Event List View-->
<div *ngIf="appointmentViewType === 'list'">
  <div class="row mr-0">
    <div class="col-sm-6">
      <label>
        {{'PAST-DAYS' | translate}}:
      </label>
      <kendo-buttongroup [selection]="'single'" class="ml-2">
        <button *ngFor="let day of pastDaysSelection;" kendoButton (click)="pastDaysSelected($event, day)"
          [ngClass]="{'k-state-active': day === selectedDays}" [toggleable]="true" class="mr-2 custom-state-button"
          style="min-width:45px;">{{day}}</button>
      </kendo-buttongroup>
    </div>
    <div class="col-sm-6">
      <div class="inputWithIcon inputWithIcon-search float-right d-flex pr-1">
        <app-advanced-mode id="eventGridAdvancedSwitch" [storageKey]="'events-list'"
          (collapsibleToggle)="enableAdvanced=$event">
        </app-advanced-mode>
      </div>
    </div>
  </div>
  <div class="mt-3">
    <kendo-grid #grid [data]="gridView" [pageable]="{ buttonCount: 5, pageSizes: pageSizes}" [pageSize]="state.take"
      [navigable]="true" [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter"
      [sortable]="true" [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
      [reorderable]="enableAdvanced" (groupChange)="groupChange($event)" (dataStateChange)="dataStateChange($event)"
      [kendoGridSelectBy]="" (cellClick)="cellClickHandler($event)" (cellClose)="cellCloseHandler($event)">
      <kendo-grid-messages noRecords="{{ 'NO-EVENTS' | translate }}">
      </kendo-grid-messages>
      <kendo-grid-column class="text-center" field="eventType" title="{{ 'EVENT-TYPE' | translate }}" [width]="30"
        [columnMenu]="false" [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.eventType" [title]="getEventIconTitle(dataItem)" [ngClass]="{
            'event-type-apt-missed': dataItem.appointment?.status === 'MISSED', 
            'event-type-apt-cancelled': dataItem.appointment?.status === 'CANCELLED', 
            'event-type-apt-confirmed': dataItem.appointment?.status === 'CONFIRMED',
            'event-type-apt-error': dataItem.appointment?.status === 'ERROR'}" [className]="dataItem.eventTypeIcon">
          </i>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen !== 'APPOINTMENTS'" field="eventType" title="{{ 'EVENT-TYPE' | translate }}"
        [width]="100" [columnMenu]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [ngClass]="{'font-weight-bold': isCaseEvent(dataItem.caseId)}">{{ dataItem.eventTypeText }}
          </span>
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-dropdown-filter [filter]="filter" [data]="eventTypes" filterField="eventType"
            selectDefaultText="{{ 'SELECT-EVENT' | translate }}" textField="text" valueField="value">
          </app-dropdown-filter>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="appointmentStatus" title="{{ 'APPOINTMENT-STATUS' | translate }}" [width]="60"
        [columnMenu]="false" [hidden]="screen !== 'APPOINTMENTS'">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.appointment?.statusText">{{ dataItem?.appointment?.statusText }}</span>
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-dropdown-filter [filter]="filter" [data]="appointmentStatuses" filterField="appointmentStatus"
            selectDefaultText="{{ 'SELECT-STATUS' | translate }}" textField="text" valueField="value">
          </app-dropdown-filter>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="encounterType" title="{{ 'ENCOUNTER-TYPE' | translate }}" [width]="120"
        [columnMenu]="false" [hidden]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span>{{ dataItem.encounterTypeText }}</span>
        </ng-template>
        <ng-template kendoGridFilterCellTemplate let-filter>
          <app-dropdown-filter [filter]="filter" [data]="encounterTypes" filterField="encounterType"
            selectDefaultText="{{ 'SELECT-ENCOUNTER' | translate }}" textField="text" valueField="value">
          </app-dropdown-filter>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="eventDateTime" title="{{ 'EVENT-DATE' | translate }}" filter="date" format="{0:g}"
        [width]="80">
        <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
          <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="gte">
            <kendo-filter-after-eq-operator></kendo-filter-after-eq-operator>
            <kendo-filter-after-operator></kendo-filter-after-operator>
            <kendo-filter-before-eq-operator></kendo-filter-before-eq-operator>
            <kendo-filter-before-operator></kendo-filter-before-operator>
          </kendo-grid-date-filter-cell>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen === 'CASE_DETAILS'" field="facility" title="{{ 'EVENT-LOCATION' | translate }}"
        [width]="120">
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen === 'APPOINTMENTS'" field="appointmentTitle" title="{{ 'TITLE' | translate }}"
        [width]="90">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.appointment?.title" title="{{dataItem?.appointment?.title}}">{{
            dataItem?.appointment?.title }}
          </span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen === 'APPOINTMENTS'" field="appointmentProvider"
        title="{{ 'PROVIDER' | translate }}" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.appointment?.provider">{{ dataItem?.appointment?.provider }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen !== 'APPOINTMENTS'" field="details" title="{{ 'EVENT-DETAILS' | translate }}"
        [width]="120">
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen === 'APPOINTMENTS'" field="appointmentSource" title="{{ 'SOURCE' | translate }}"
        [width]="60" [filterable]="false" [sortable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.appointment?.source">{{ dataItem?.appointment?.source | translate }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen === 'APPOINTMENTS'" field="appointmentCreatedBy"
        title="{{ 'CREATED-BY' | translate }}" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem?.appointment?.createdBy">{{ dataItem?.appointment?.createdBy }}</span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen !== 'APPOINTMENTS'" field="tasks" title="{{ 'TASKS' | translate }}" [width]="40"
        class="text-center" [filterable]="false" [sortable]="false">
      </kendo-grid-column>
      <kendo-grid-column *ngIf="screen === 'CASE_DETAILS'" class="text-center" field="related" [width]="100"
        title="{{ 'EVENT-RELATED' | translate }}" filter="boolean" editor="boolean">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.related" class="fas fa-check"></i>
        </ng-template>
        <ng-template kendoGridEditTemplate>
          <form [formGroup]="editForm">
            <input type="checkbox" id="relatedCheckbox" formControlName="related" kendoCheckBox />
            <label class="k-checkbox-label" for="relatedCheckbox"></label>
          </form>
        </ng-template>
      </kendo-grid-column>
      <ng-template kendoGridDetailTemplate let-dataItem>
        <kendo-grid [data]="[dataItem]" [resizable]="false"
          *ngIf="dataItem.referral !== null && dataItem.referral.id > 0">
          <kendo-grid-messages noRecords="{{ 'NO-REFERRALS' | translate }}">
          </kendo-grid-messages>
          <kendo-grid-column [width]="25" title="{{ 'REFERRED-FROM' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span *ngIf="dataItem.referral?.from?.name?.fullName">{{dataItem.referral?.from?.name?.fullName}}</span>
              <span
                *ngIf="dataItem.referral?.eventReferral?.referredFromName">{{dataItem.referral?.eventReferral?.referredFromName
                }}
                <span
                  *ngIf="dataItem?.referral?.eventReferral?.referredFromOrganizationName">({{dataItem?.referral?.eventReferral?.referredFromOrganizationName}})
                </span>
              </span>
              <span
                *ngIf="!dataItem.referral?.eventReferral?.referredFromName">{{dataItem.referral?.referredFromUser?.fullName}}</span>
              <span *ngIf="dataItem.referral !== null && dataItem.referral.referredFromUser !== null && dataItem.referral.organization !== null &&
                !dataItem?.referral?.eventReferral?.referredFromOrganizationName">
                ({{dataItem.referral?.referredFromUser?.organization?.name}})
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="25" title="{{ 'REFERRED-TO' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem>
              <span *ngIf="dataItem.referral?.referredToCommunityProgram?.referralContactName">
                {{dataItem.referral?.referredToCommunityProgram?.referralContactName}}
                <span
                  *ngIf="dataItem.referral?.referredToCommunityProgram?.organization?.name">({{dataItem.referral?.referredToCommunityProgram?.organization?.name}})
                </span>
              </span>
              <span *ngIf="dataItem.referral?.eventReferral?.referredServiceName">
                {{dataItem.referral?.eventReferral?.referredServiceName}}
                <span
                  *ngIf="dataItem.referral?.eventReferral?.referredToOrganizationName">({{dataItem.referral?.eventReferral?.referredToOrganizationName}})
                </span>
              </span>
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="25" title="{{ (dataItem.referral !== null && 
              (dataItem.referral.referredToCommunityProgram !== null  || dataItem?.referral?.eventReferral?.referredServiceName) ? 
              'COMMUNITY-SERVICE-TYPE' : 'REFERRED-REASON') | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{dataItem.referral.reason}}
            </ng-template>
          </kendo-grid-column>
          <kendo-grid-column [width]="25" title="{{ 'REFERRED-DATE' | translate }}">
            <ng-template kendoGridCellTemplate let-dataItem>
              {{ intl.formatDate(intl.parseDate(dataItem.referral.date), "g") }}
            </ng-template>
          </kendo-grid-column>
        </kendo-grid>
        <kendo-grid-column *ngIf="screen === 'APPOINTMENTS'" field="appointmentSource"
          title="{{ 'SOURCE' | translate }}" [width]="40">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span *ngIf="dataItem?.appointment?.source">{{ dataItem?.appointment?.source }}</span>
          </ng-template>
        </kendo-grid-column>
        <br />
        <app-event-task-list [enableAdvanced]="enableAdvanced" [caseId]="caseId" [eventItem]="dataItem"
          (openTaskDialog)="initiateTask($event)">
        </app-event-task-list>
      </ng-template>
      <kendo-grid-command-column *ngIf="screen === 'APPOINTMENTS'" [width]="80" title="{{ 'ACTIONS' | translate }}"
        class="text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
          <i *ngIf="dataItem.appointment && dataItem.appointment.status" class="fas fa-lg mr-2" [ngClass]="{'fa-edit': (dataItem.appointment.status === 'SCHEDULED' || dataItem.appointment.status === 'CONFIRMED'), 
            'fa-eye': !(dataItem.appointment.status === 'SCHEDULED' || dataItem.appointment.status === 'CONFIRMED')}"
            title="{{ ((dataItem.appointment.status === 'SCHEDULED' || dataItem.appointment.status === 'CONFIRMED') ? 'EDIT' : 'VIEW') | translate }}"
            (click)="editHandler(dataItem)">
          </i>
          <i class="fas fa-trash-alt fa-lg mr-2" title="{{ 'DELETE-APPOINTMENT' | translate}}"
            (click)="openDeleteAppointment(dataItem)">
          </i>
          <i class="fas fa-calendar-times fa-lg mr-2" style="color:#bc7410"
            title="{{ 'CANCEL-APPOINTMENT' | translate }}"
            [ngClass]="{'extra-padding': !canResendAppointment(dataItem)}" (click)="cancelAppointment(dataItem)">
          </i>
          <i class="fas fa-envelope fa-send-document-action fa-lg mr-2"
            title="{{ 'SEND-APPOINTMENT-TO-PATIENT' | translate:patientLabel }}"
            (click)="confirmResendAppointment(dataItem)" *ngIf="canResendAppointment(dataItem)">
          </i>
        </ng-template>
      </kendo-grid-command-column>
    </kendo-grid>
    <span translate [translateParams]="{value: eventSavedDate | date:'h:mm:ss a'}" *ngIf="eventSaved"
      class="float-right data-saved-success" [@fadeAnimation]='in'> {{'EVENT-SAVED'}}
    </span>
  </div>
</div>

<!--Event Scheduler View (Appointment)-->
<div *ngIf="screen==='APPOINTMENTS' && appointmentViewType==='calendar'">
  <app-event-scheduler [memberId]="memberId" (refresh)="schedulerOnRefresh()"></app-event-scheduler>
</div>

<button *ngIf="screen === 'APPOINTMENTS'" kendoButton [primary]="true" type="button" class="mt-3 mb-2 float-right mr-1"
  (click)="addEvent()">
  {{ 'ADD-APPOINTMENT' | translate }}<i class="far fa-plus"></i>
</button>

<!-- task form dialog -->
<app-task-add [dialogOpened]="taskDialogOpened" [eventId]="selectedEvent.id" [caseId]="selectedEvent.caseId"
  [assigneeId]="" (cancelling)="taskDialogOpened=false;" (save)="afterTaskAdded($event)">
</app-task-add>

<app-event-edit-appointment *ngIf="isNewClicked || appointmentViewType==='list'" [isNew]="isNew" [memberId]="memberId"
  [model]="editDataItem" (cancelling)="cancelChangesHandler()" (save)="saveChangesHandler()">
</app-event-edit-appointment>

<app-event-cancel-appointment *ngIf="appointmentViewType === 'list'" [model]="cancelDataItem"
  (cancelling)="cancelCancelHandler()" (save)="saveCancelHandler()">
</app-event-cancel-appointment>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="deleteDialogOpened = false"
  [minWidth]="250" [width]="450">
  <p>{{ 'CONFIRM-APPOINTMENT-DELETION' | translate }}</p>
  <span class="k-font-weight-bold">{{appointmentToDelete?.appointment?.title}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="deleteDialogOpened = false">{{ 'NO' | translate }}</button>
    <button appPreventClick kendoButton (click)="deleteAppointment()" [primary]="true">{{ 'YES' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog *ngIf="resendAppointmentDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
  (close)="resendAppointmentDialogOpened = false">
  <p>{{'CONFIRM-RESEND-APPOINTMENT-CONFIRMATION' | translate:notifyPatientTypeLabel}}</p>
  <span class="k-font-weight-bold">{{selectedAppointment.appointment.title}}</span>
  <kendo-dialog-actions>
    <button kendoButton (click)="resendAppointmentDialogOpened = false">{{'NO' | translate}}</button>
    <button appPreventClick kendoButton (click)="resendAppointmentEmail()">{{'YES' | translate}}</button>
  </kendo-dialog-actions>
</kendo-dialog>